import React from 'react';

const renderContent = (content, desc) => {
  if (content) {
    return content;
  }
  return (<p>{desc}</p>);
};

export const EffectsModal = ({
  title,
  valid,
  desc,
  content,
}) => ({
  title,
  body: (
    <div>
      {valid
          && (
          <div>
            Valid values:
            {' '}
            <b>{valid}</b>
            <br />
            <br />
          </div>
          )}
      {renderContent(content, desc)}
    </div>
  ),
});
